// extracted by mini-css-extract-plugin
export default {"form":"PasswordReset_form__DHaUA","input":"PasswordReset_input__4f3lz","resetButton":"PasswordReset_resetButton__BYe0W"};